import React from 'react'
import { styled } from '@mui/material'
import { spacingSelector } from '../../theme/selectors'
import { GoogleDownloadLink } from '../GoogleDownloadLink'
import { IOSDownloadLink } from '../IOSDownloadLink'

export const Wrapper = styled('div')`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${spacingSelector(0.5)};
  flex-wrap: wrap;
  justify-content: center;
`

export interface AppDownloadLinksProps {
  /** iOS App Store URL. Defaults to the Qwick for Professionals (pro) app. */
  iosHref?: string
  /** Google Play URL. Defaults to the Qwick for Professionals (pro) app. */
  googleHref?: string
}

export const AppDownloadLinks: React.FunctionComponent<
  AppDownloadLinksProps
> = ({ iosHref, googleHref }) => {
  return (
    <Wrapper>
      <IOSDownloadLink href={iosHref} />{' '}
      <GoogleDownloadLink href={googleHref} />
    </Wrapper>
  )
}
